import { useState, useEffect } from "react";
import { fetchResource } from "../lib/api";

const cache = {};

// Fetches a named resource. Backed by JSON today, swappable to a REST API
// via lib/api.js with zero component changes.
export function useData(name) {
  const [data, setData] = useState(cache[name] || null);
  const [loading, setLoading] = useState(!cache[name]);

  useEffect(() => {
    let alive = true;
    if (cache[name]) {
      setData(cache[name]);
      setLoading(false);
      return;
    }
    fetchResource(name)
      .then((json) => {
        if (!alive) return;
        cache[name] = json;
        setData(json);
        setLoading(false);
      })
      .catch((err) => {
        if (alive) {
          console.error(`[useData] Failed to load resource "${name}":`, err);
          setLoading(false);
        }
      });
    return () => { alive = false; };
  }, [name]);

  return { data, loading };
}
